<template>
  <div
    class="checkbox-input"
    :class="{
      'disabled': disabled,
      'checked': value
    }"
  >
    <div
      class="click-area"
      @click.stop="updateValue"
    >
      <div class="control__indicator" />
      <label
        v-if="text"
        v-text="text"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CheckboxInput',
    data () {
      return {
      }
    },
    props: {
      value: {
        default: false,
        type: Boolean
      },
      text: {
        default: '',
        type: String
      },
      disabled: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      updateValue () {
        let self = this
        if (!self.disabled) {
          self.$emit('input', !self.value)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../uikit';

  .checkbox-input {
    height: 16px;
    font-size: 0;
    box-sizing: border-box;

    .click-area {
      display: inline-block;
      cursor: pointer;
      height: 16px;
    }

    label {
      display: inline-block;
      cursor: pointer;
      vertical-align: top;
      margin-left: 10px;
      font-size: 13px;
      line-height: 16px;
      font-weight: 400;
      color: $mediumGreyFont;
      user-select: none;
    }

    .control__indicator {
      display: inline-block;
      vertical-align: top;
      height: 16px;
      width: 16px;
      border-radius: 2px;
      background-color: $darkGreyBackground;

      &:after {
        content: '';
        position: relative;
        display: none;
        left: 5px;
        top: 1px;
        width: 4px;
        height: 10px;
        border: solid $lightGreyBackground;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        border-radius: 2px;
      }
    }

    &:hover {
      label {
        color: $darkGreyFont;
      }
    }
    &.disabled {
      label {
        color: $darkGreyBackground;
      }
      .control__indicator {
        background-color: $mediumGreyBackground;
      }
    }
    &.checked {
      label {
        color: $mediumGreyFont;
      }
      &:hover {
        label {
          color: $darkGreyFont;
        }
      }
      .control__indicator {
        background-color: $pendingBlue;
        &:after {
          display: block;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/checkbox/CheckboxInput.vue